import script from "./AtividadesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AtividadesCard.vue?vue&type=script&setup=true&lang=js"

import "./AtividadesCard.vue?vue&type=style&index=0&id=75487780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75487780"]])

export default __exports__